export default "__VITE_ASSET__kUShb1T1__"